/**
 * Created by Caroline on 2019/11/25 0025.
 *
 */
export const GET_ACTIVITY_ID = 'GET_ACTIVITY_ID'
export const SET_ACTIVITY_ID = 'SET_ACTIVITY_ID'
export const GET_LIVE_DETAIL = 'GET_LIVE_DETAIL'
export const GET_SHARE_DATA = 'GET_SHARE_DATA'

export const SEND_MODE = 'SEND_MODE'
export const UPDATE_MODE = 'UPDATE_MODE'
export const UPDATE_TAGS = 'UPDATE_TAGS'
export const ADD_BLESSING = 'ADD_BLESSING'
export const UPDATE_LOTTERY = 'UPDATE_LOTTERY'

export const GET_IMAGE_LIST = 'GET_IMAGE_LIST'
export const GET_BLESSING_LIST = 'GET_BLESSING_LIST'
export const UPDATE_BLESSING_LIST_BY_NEW = 'UPDATE_BLESSING_LIST_BY_NEW'
export const GET_LOTTERY = 'GET_LOTTERY'

export const UPDATE_WINDOW_SIZE = 'UPDATE_WINDOW_SIZE'
export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'

export const UPDATE_GLOBAL_FONT = 'UPDATE_GLOBAL_FONT'



// WEBPACK FOOTER //
// ./src/store/types.js